/**
 * collection-cart.js
 * 1. .collection-play  — triggers NVV audio player
 * 2. .collection-cart  — AJAX add-to-cart, opens Dawn cart drawer
 */

(function () {
  if (window.__nvvCollectionCartBound) return;
  window.__nvvCollectionCartBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.collection-play');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof window.nvvPlayCard === 'function') {
      window.nvvPlayCard(btn);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.collection-cart[data-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variant;
    if (!variantId) return;

    var isPreorder = String(btn.dataset.isPreorder || '').toLowerCase() === 'true';
    var releaseDate = btn.dataset.releaseDate || '';

    var originalHTML = btn.innerHTML;
    btn.setAttribute('disabled', 'disabled');
    btn.style.opacity = '0.4';

    addToCart(variantId, btn, {
      isPreorder: isPreorder,
      releaseDate: releaseDate
    })
      .then(function () {
        showFeedback(btn, 'success', originalHTML);
      })
      .catch(function (err) {
        console.error('[collection-cart]', err);
        showFeedback(btn, 'error', originalHTML);
      });
  });

  function addToCart(variantId, triggerBtn, meta) {
    var lineItem = { id: Number(variantId), quantity: 1 };

    if (meta && meta.isPreorder && meta.releaseDate) {
      lineItem.properties = {
        'Release Date': meta.releaseDate,
        'Ship Date': meta.releaseDate
      };
    }

    var config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [lineItem]
      })
    };

    return fetch(window.routes.cart_add_url + '.js', config)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw data; });
        return r.json();
      })
      .then(function () {
        return refreshCartUI(triggerBtn, variantId);
      });
  }

  function refreshCartUI(triggerBtn, variantId) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    var url = window.routes.cart_url + '?sections=' + encodeURIComponent(sectionIds.join(','));

    return fetch(url, {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Unable to refresh cart sections');
        return r.json();
      })
      .then(function (sections) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.setActiveElement(triggerBtn);
          cartDrawer.renderContents({
            id: variantId,
            sections: sections
          });
        } else {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            bubble.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
          }
        }

        if (window.sessionStorage) {
          try {
            window.sessionStorage.removeItem('nvvPreorderModalDismissed');
          } catch (e) {}
        }

        triggerMixedCartCheck(variantId);
      });
  }


  function triggerMixedCartCheck(variantId) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { source: 'nvv-collection-cart', variantId: variantId }
    }));

    if (typeof window.nvvCheckCartForMixedItems === 'function') {
      window.nvvCheckCartForMixedItems();

      window.setTimeout(function () {
        window.nvvCheckCartForMixedItems();
      }, 350);

      window.setTimeout(function () {
        window.nvvCheckCartForMixedItems();
      }, 1000);
    }
  }

  function showFeedback(btn, type, originalHTML) {
    var checkSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    var crossSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    btn.innerHTML = type === 'success' ? checkSVG : crossSVG;
    setTimeout(function () {
      btn.innerHTML = originalHTML;
      btn.removeAttribute('disabled');
      btn.style.opacity = '';
    }, 1400);
  }
})();
